/* eslint-disable guard-for-in */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react'
import {
  Tabs, Tab, Box, Typography, Checkbox, InputLabel,
  MenuItem, FormControl, Select
} from '@mui/material'
import { Popover, Button, Icon, TextField } from '@material-ui/core';
import FuseLoading from '@fuse/core/FuseLoading';
import multiFormatFileManager from "@fuse/utils/multiFormatFileManager";
import { useDispatch, useSelector } from "react-redux";
import CustomDatePickerV2 from '@fuse/components/customDatePicker/DatePickerV2'
import useToast from "@fuse/hooks/useToast";
import useRouter from '@fuse/hooks/useRouter';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { SearchDropDownListPaginationComponent } from 'helper/SearchDropDownPaginationList';
import { getAllCompany } from 'app/api/company';
import { getAllRoles, getAllUser } from 'app/api/user';
import { getAllAsset, getAllAssetAccessory, getAllAssetAccessoryCategory, getAllAssetCategory, getAllAssetCustomAttribute, getAllAssetManufacturer, getAllAssetModel, getAllAssetServiceProvider, getAllAssetStatus } from 'app/api/asset';
import { getAllContracPaymentTerm, getAllContracServiceLevelAgrement, getAllContract, getAllContractStatus, getAllContracType } from 'app/api/contract';
import { getAllDepartment, getAllLocation, getAllLocationType } from 'app/api/location';
import { actions, assets_network_status, assets_source, contract_master, contract_status, source, asset_notification_status, serviceTemplateType } from 'helper/constant';
import { getAllCategory, getAllPriority, getAllServiceRequest, getAllSource, getAllStatus } from 'app/api/service-request';
import { titleCase, ucFirst } from 'helper/common';
import dayjs from 'dayjs';
import { setGroupViewTabValue } from "../../../app/main/reports/store/reportViewDialogReducer";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const AgGridFilterGroupView = ({ tableRef, setRowGroupPanelShow, groupByArrFromList,
  tableName, onClick = () => { }, displayTableName = '', allArchiveId = [], bulkAssetArchive = () => { },
  handleServiceTicketCreation = () => { }, onClickAddButton = () => { }, customFilterData = null, clearRedirectionFilter = () => { }, forActivity = false,
  serviceRequestTotalRecords, hideTableName = false, activityModuleName, tableIndex
}) => {
  const [gridRef, setGridRef] = useState(null);
  const [columns, setColumns] = useState([])
  const [tabValue, setTabValue] = useState(tableIndex ?? 0);
  const [columnHeaderAndValueMap, setColumnHeaderAndValueMap] = useState([]);
  const [filterColumnHeaderAndValueMap, setFilterColumnHeaderAndValueMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [dateInputValOne, setDateInputValOne] = useState({
    date: null,
    error: false
  })
  const [dateInputValTwo, setDateInputValTwo] = useState({
    date: null,
    error: false
  })
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [columnNameSearchValue, setColumnNameSearchValue] = useState(null);
  const [selectAll, setSelectAll] = useState(true);
  const dispatch = useDispatch();
  const toast = useToast(dispatch);
  const [fileDownloadLoader, setFileDownloadLoader] = useState(null);
  const showActivity = ['asset', 'Model', 'Manufacture', 'asset_category', 'service_ticket_priority', 'asset_status', 'custom_attributes', 'user', 'service_provider',
    'accessory_category', 'Accessory', 'Contract', 'service_request_status', 'service_request_category', 'payment_term', 'service_request_source', 'service_request',
    'agents', 'customer_management', 'contract_tag', 'Contract Types', 'service_level_agreement', 'shipping', 'location_type', 'department', 'asset activity', 'service_template']
  const dropDownFilterModule = ['asset', 'Model', 'Archived Asset', 'Manufacture', 'asset_category', 'asset_status', 'custom_attributes', 'department', 'user',
    'Insight log', 'service_provider', 'service_request', 'Archived Service Tickets', 'activity_logs', 'Alert List', 'Unresolved Alert List', 'service_template',
    'accessory_category', 'Accessory', 'Contract', 'Archived Contract', 'payment_term', 'contract_tag', 'Contract Types',
    'service_level_agreement', 'shipping', 'location_type', 'service_request_category', 'service_request_status', 'service_request_source', 'service_ticket_priority']
  const hideExportAs = ['service_ticket_priority', 'service_request_status', 'service_request_category',
    'service_request_source', 'accessory_category', 'Accessory', 'custom_attributes', 'asset_status', 'asset_category',
    'payment_term', 'contract_tag', 'Contract Types', 'service_level_agreement', 'location_type', 'department',
    'customer_management', 'agents', 'Insight log', 'Alert List', 'Unresolved Alert List', 'service_template'
  ]
  const router = useRouter();
  const dropdownFilterColumns = ['Company Name', 'User', 'User Name', 'Agent Name', 'Status', 'Contract Number', 'Contract Tag', 'Model', 'Model No', 'Customer Name',
    'Model Name', 'Model Number', 'Category', 'Manufacturer', 'Location', 'Type', 'Service Provider', 'Client Name', 'Serial Number',
    'Priority', 'Status', 'Location Type Name', 'Location Type', 'Department Name', 'Accessory Category', 'Model Number', 'Location', 'Type', 'Service Provider', 'Service Provider Name', 'Client Name', 'Serial Number',
    'Mac Address', 'Source', 'Network Status', 'Category Name', 'Status Name', 'Service Ticket Category Name', 'Service Ticket Source Name', 'Priority Name', 'service_template',
    'Contract Status', 'Master', 'New/renew', 'Email', 'Role Name', 'Asset Category', 'Model Attribute', 'Asset Status', 'Payment Term Name', 'Manufacturer Name', 'Attribute Name',
    'Contract Tag Name', 'Contract Type Name', 'Service Level Agreement Name', 'Ticket Id', 'Ticket Number', 'Location Name', 'Department', 'Action', 'User Role', 'Name', 'Accessory', 'Accessory Name', 'Notification Status']

  const asset_count = useSelector(
    (state) => state?.reportApp?.reportViewDialogReducer?.asset_count
  );

  function handleChangeTab(event, newValue) {
    if (rowSelectionCheckbox && Object.keys(rowSelectionCheckbox)?.length === 0) return
    onClick(newValue)
    setTabValue(newValue)
    dispatch(setGroupViewTabValue(newValue))
  }

  function hideAddButton() {
    if (['Archived Service Tickets', 'user_audit_logs', 'activity_logs', 'Contract', 'Archived Contract', 'payment_term', 'asset_category', 'shipping', 'location_type', 'department', 'user', 'Insight log', 'Alert List', 'service_provider', 'custom_attributes', 'Unresolved Alert List',
      'asset', 'Model', 'Accessory', 'accessory_category', 'asset_status', 'Archived Asset', 'Manufacture', 'contract_tag', 'Contract Types', 'service_level_agreement']?.includes(tableName)) {
      return false
    }
    return true
  }

  // useEffect(() => {
  //   requestIdleCallback(()=>{
  //     setGridRef(tableRef)
  //     setColumns((tableRef?.current?.columnApi?.getAllColumns())?.filter(item => item.colDef.headerName !== "Actions"))

  //   })

  //   forActivity && setTabValue(1)
  // }, [])

  useEffect(() => {
    if (!tableRef?.current?.api) return;
    setGridRef(tableRef)

    const { api } = tableRef.current;
    const allColumns = api.getAllGridColumns();

    const headerFieldMap = allColumns
      .map(col => col.getColDef())
      .filter(def => def?.headerName && def.headerName !== "Actions")
      .reduce((acc, def) => {
        acc[def.headerName] = def.field;
        return acc;
      }, {});

    setColumnHeaderAndValueMap(headerFieldMap);
  }, [tableRef?.current]);

  useEffect(() => {
    // setColumns((tableRef?.current?.columnApi?.getAllColumns())?.filter(item => item.colDef.headerName !== "Actions"))
    const allGridColumns = tableRef?.current?.api?.getColumns?.() || [];
    const filteredColumns = allGridColumns.filter(def => def?.colId && def.colId !== "actions")
    // .map(col => col.getColDef())

     setColumns(filteredColumns);
     forActivity && setTabValue(1)
  }, [columnHeaderAndValueMap]);

  /* =========================================== */

  /** ************Row Selection***************** */
  const [rowSelected, setRowSelected] = useState(false)
  /* =========================================== */

  /** ************Filter*********************** */
  const [filterAction, setFilterAction] = useState({
    "Contains": "contains",
    "Not Contains": "notContains",
    "Equal": "equals",
    "Not Equal": "notEqual",
    "Starts With": "startsWith",
    "Ends With": "endsWith"
  })
  const filterTemp = {
    column: '',
    action: '',
    inputVal: '',
    operator: '',
    actionTwo: '',
    inputValTwo: '',
    error: {
      actionError: false,
      actionTwoError: false
    }
  }

  const serviceTicketCreatedAtFilter = {
    "Equal": "equals",
    "Not Equal": "notEqual",
    "From": "from",
  }

  const dateFilter = {
    "Equal": "equals",
    "Not Equal": "notEqual"
  }


  // useEffect(()=>{
  //   setColumnHeaderAndValueMap((() => {
  //     return (tableRef?.current?.columnApi?.getAllColumns())?.filter(item => item.colDef.headerName !== "Actions")?.reduce((res, curr) => {
  //       res[curr.colDef.headerName] = curr.colDef.field;
  //       return res
  //     }, {})
  //   })())
  //   // requestIdleCallback(()=>{
  //   //   setColumnHeaderAndValueMap((() => {
  //   //     return (tableRef?.current?.columnApi.getAllColumns())?.filter(item => item.colDef.headerName !== "Actions")?.reduce((res, curr) => {
  //   //       res[curr.colDef.headerName] = curr.colDef.field;
  //   //       return res
  //   //     }, {})
  //   //   })())
  //   // })

  //   // setColumnHeaderAndValueMap(columns?.reduce((res, curr) => {
  //   //   res[curr.colDef.headerName] = curr.colDef.field;
  //   //   return res
  //   // }, {}))
  // },[])

  const [openCustomFilterUi, setOpenCustomFilterUi] = useState(false)
  const [allFilter, setAllFilter] = useState([{ ...filterTemp }])
  const [initialFilterApplied, setInitialFilterApplied] = useState(false)

  function openFilter() {
    setOpenCustomFilterUi(true)
  }

  const handleColumnSelect = (event, index) => {
    setSelectedColumnName(event.target.value)
    if (allFilter[index]?.column?.toLowerCase()?.includes('date') || allFilter[index]?.column?.toLowerCase()?.includes('time')) {
      setDateInputValOne(null)
      setDateInputValTwo(null)
    }

    setAllFilter(prevFilters => {
      prevFilters[index].column = event.target.value;
      prevFilters[index].inputVal = '';
      prevFilters[index].inputValTwo = '';
      return [...prevFilters];
    });
  }

  const getKeyName = (obj, searchValue) => {

    if (!searchValue) return ''

    for (const [key, value] of Object.entries(obj)) {
      if (value === searchValue) {
        return key
      }
    }

    return ''
  }

  const flattenFilter = (filterObj) => {
    if (!filterObj) return
    setIsLoading(true)
    const filterArr = []
    try {
      for (const [key, value] of Object?.entries(filterObj)) {
        const dateRange = (['service_request', 'Alert List'].includes(tableName) && (value?.type === 'range' || value?.filter?.includes('~')))
        if (filterObj[key]?.condition1 || filterObj?.condition2 || dateRange) {
          if (key?.toLowerCase().includes('date') || key?.toLowerCase().includes('time')) {
            const dateValue = dateRange ? value?.filter?.split('~')?.[0] : filterObj[key]?.condition1?.filter
            const dateValue2 = dateRange ? value?.filter?.split('~')?.[1] : filterObj[key]?.condition2?.filter
            filterArr.push({
              ...filterTemp,
              column: getKeyName(columnHeaderAndValueMap, key),
              action: dateRange ? 'From' : getKeyName(filterAction, filterObj[key]?.condition1?.type),
              inputVal: { date: new Date(dateValue)?.toISOString(), error: false },
              operator: filterObj[key]?.operator ?? '',
              actionTwo: dateRange ? 'To' : getKeyName(filterAction, filterObj[key]?.condition2?.type),
              inputValTwo: { date: new Date(dateValue2)?.toISOString(), error: false }
            })
          } else {
            filterArr.push({
              ...filterTemp,
              column: getKeyName(columnHeaderAndValueMap, key),
              action: getKeyName(filterAction, filterObj[key]?.condition1?.type),
              inputVal: filterObj[key]?.condition1?.filter,
              operator: filterObj[key]?.operator,
              actionTwo: getKeyName(filterAction, filterObj[key]?.condition2?.type),
              inputValTwo: filterObj[key]?.condition2?.filter,
            })
          }
        } else if (key?.toLowerCase().includes('date') || key?.toLowerCase().includes('time')) {
          // setDateInputValOne({date: new Date().toISOString(), error: false})
          filterArr.push({
            ...filterTemp,
            column: getKeyName(columnHeaderAndValueMap, key),
            action: getKeyName(filterAction, filterObj[key]?.type),
            inputVal: value?.filter,
            operator: filterObj[key]?.operator,
            actionTwo: '',
            inputValTwo: ''
          })
        } else {
          filterArr.push({
            ...filterTemp,
            column: getKeyName(columnHeaderAndValueMap, key),
            action: getKeyName(filterAction, filterObj[key]?.type),
            inputVal: filterObj[key]?.filter,
            operator: filterObj[key]?.operator,
            actionTwo: '',
            inputValTwo: '',
            id: filterObj[key]?.id
          })
        }
        if (filterArr?.length > 0) {
          setAllFilter(filterArr)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (customFilterData) return
    requestIdleCallback(() => {
      if (!tableRef?.current) return
      const appliedFilter = tableRef?.current?.api?.getFilterModel()
      if (Object.keys(appliedFilter || {})?.length !== 0 && !initialFilterApplied) {
        const filter = tableRef?.current.filterModelArr
        setOpenCustomFilterUi(true)
        flattenFilter(filter)
        setInitialFilterApplied(true)
      }
    })
  }, [tableRef?.current?.api?.getFilterModel()])

  const handleFilterActionSelect = (event, index) => {
    setAllFilter(prevFilters => {
      prevFilters[index].action = event.target.value;
      prevFilters[index].error.actionError = false;
      return [...prevFilters];
    });
    if (['service_request', 'Alert List'].includes(tableName) && event.target.value === 'From') {
      setAllFilter(prevFilters => {
        prevFilters[index].actionTwo = 'To';
        prevFilters[index].error.actionError = false;
        return [...prevFilters];
      });
    }
  }

  const handleFilterInput = (event, index, custom = false) => {
    if ((allFilter[index].column?.toLowerCase().includes('date') || allFilter[index].column?.toLowerCase()?.includes('time'))) {
      setAllFilter(prevFilters => {
        prevFilters[index].inputVal = dayjs(event).format('YYYY-MM-DD');
        return [...prevFilters];
      });
    } else if ((dropdownFilterColumns?.includes(allFilter[index].column?.trimEnd()) && dropDownFilterModule?.includes(tableName)) || (customFilterData && ['Status', 'Location']?.includes(Object.keys(customFilterData)[0]))) {
      setAllFilter(prevFilters => {
        prevFilters[index].inputVal = (customFilterData && ['Status', 'Location']?.includes(Object.keys(customFilterData)[0]) && custom) ? ucFirst(event.target.value) : event
        return [...prevFilters];
      });
    } else {
      setAllFilter(prevFilters => {
        prevFilters[index].inputVal = event.target.value;
        return [...prevFilters];
      });
    }
  }

  const handleAndOrBtn = (event, operator, index) => {
    setAllFilter(prevFilters => {
      prevFilters[index].operator = operator.toUpperCase();
      return [...prevFilters];
    });
  }

  const handleFilterActionSelectTwo = (event, index) => {
    setAllFilter(prevFilters => {
      prevFilters[index].actionTwo = event.target.value;
      prevFilters[index].error.actionTwoError = false;
      return [...prevFilters];
    });
  }

  const handleFilterInputTwo = (event, index) => {
    if ((allFilter[index].column?.toLowerCase()?.includes('date') || allFilter[index].column?.toLowerCase()?.includes('time'))) {
      setAllFilter(prevFilters => {
        prevFilters[index].inputValTwo = dayjs(event).format('YYYY-MM-DD');
        return [...prevFilters];
      });
    } else if ((dropdownFilterColumns?.includes(allFilter[index].column?.trimEnd()) && dropDownFilterModule?.includes(tableName))) {
      setAllFilter(prevFilters => {
        prevFilters[index].inputValTwo = event
        return [...prevFilters];
      });
    } else {
      setAllFilter(prevFilters => {
        prevFilters[index].inputValTwo = event.target.value;
        return [...prevFilters];
      });
    }
  }

  const addAnotherFilter = () => {
    setFilterAction({
      "Contains": "contains",
      "Not Contains": "notContains",
      "Equal": "equals",
      "Not Equal": "notEqual",
      "Starts With": "startsWith",
      "Ends With": "endsWith"
    })
    setAllFilter(prevArray => [...prevArray, { ...filterTemp }])
  }


  function handleApplyFilter(customFilterColumn) {
    requestIdleCallback(() => {
      if (gridRef?.current) {
        // Get the grid API
        const gridApi = gridRef.current.api;
        // for both side filled
        const filterModelArr = {}
        allFilter.forEach((item, index) => {
          const dateRange = (['service_request', 'Alert List'].includes(tableName) && item?.action === 'From' && item?.actionTwo === 'To')
          if (dateRange && (!item?.inputVal || !item?.inputValTwo)) {
            toast.error('Please select value')
            return
          }

          if (item.inputVal && item.inputValTwo && !dateRange) {
            if (item.inputVal && item.inputValTwo && !item.operator) {
              toast.error('Please select and/or')
              return
            }
            // if (item.inputVal && item.inputValTwo && (!filterAction[item.action] || !filterAction[item.actionTwo])) {
            //   toast.error('Please select operator')
            //   return
            // }
            if (item.action === '') {
              setAllFilter(prevFilters => {
                prevFilters[index].error.actionError = true;
                return [...prevFilters];
              });
              toast.error("Please select operator")
            }
            if (item.actionTwo === '') {
              setAllFilter(prevFilters => {
                prevFilters[index].error.actionTwoError = true;
                return [...prevFilters];
              });
              toast.error("Please select operator")
            }

            if ((item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time"))) {
              filterModelArr[columnHeaderAndValueMap[item.column]] = {
                filterType: "date",
                operator: item.operator,
                condition1: {
                  filterType: "date",
                  type: ['service_request', 'asset', 'Alert List', 'Insight log', 'Unresolved Alert List'].includes(tableName) ? filterAction[item.action] : ['contains', 'equals'].includes(filterAction[item.action]) ? 'contains' : 'notContains',
                  filter: (tableName !== 'asset' && tableName !== 'user_audit_logs') ? dayjs(item.inputVal?.date || item?.inputVal).format('YYYY-MM-DD') : item.inputVal?.date || item?.inputVal
                },
                condition2: {
                  filterType: "date",
                  type: ['service_request', 'asset', 'Alert List', 'Insight log', 'Unresolved Alert List'].includes(tableName) ? filterAction[item.actionTwo] : ['contains', 'equals'].includes(filterAction[item.actionTwo]) ? 'contains' : 'notContains',
                  filter: (tableName !== 'asset' && tableName !== 'user_audit_logs') ? dayjs(item.inputValTwo?.date || item?.inputValTwo).format('YYYY-MM-DD') : item.inputValTwo?.date || item?.inputValTwo
                }
              }
            } else {
              filterModelArr[columnHeaderAndValueMap[item.column] ?? customFilterColumn] = {
                filterType: "text",
                operator: item.operator,
                condition1: {
                  filterType: "text",
                  type: filterAction[item.action],
                  filter: typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal,
                  id: item.inputVal.id
                },
                condition2: {
                  filterType: "text",
                  type: filterAction[item.actionTwo],
                  filter: typeof item.inputValTwo === 'object' ? item.inputValTwo.label : item.inputValTwo,
                  id: item.inputValTwo.id
                }
              }
            }

          } else if (item.inputVal) {
            if (item.action === '') {
              setAllFilter(prevFilters => {
                prevFilters[index].error.actionError = true;
                return [...prevFilters];
              });
              toast.error("Please select operator")
              return
            }
            if ((item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time"))) {
              if (dateRange ? false : filterAction[item.action] !== 'equals' && filterAction[item.action] !== 'notEqual') {
                toast.error(`Date filter can't work with ${item.action}`)
                return
              }
              const filterData = dateRange ? `${dayjs(item.inputVal?.date ?? item?.inputVal).format('YYYY-MM-DD')}~${dayjs(item.inputValTwo?.date ?? item?.inputValTwo).format('YYYY-MM-DD')}` :
                (tableName !== 'asset' && tableName !== 'user_audit_logs') ? dayjs(item.inputVal).format('YYYY-MM-DD') : item.inputVal

              filterModelArr[columnHeaderAndValueMap[item.column]] = {
                filterType: "date",
                type: dateRange ? 'range' : filterAction[item.action],
                filter: filterData,
              }
            } else {
              filterModelArr[columnHeaderAndValueMap[item.column] ?? customFilterColumn] = {
                filterType: "text",
                type: filterAction[item.action],
                filter: typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal,
                id: item.inputVal.id
              }
            }
          }
        })

        tableRef.current = {
          ...tableRef.current,
          filterModelArr
        }

        gridApi.setFilterModel(filterModelArr);
      }
    })

  }

//   const clearFilter = () => {
//   requestIdleCallback(() => {
//     if (!gridRef?.current) {
//       console.warn('Grid not ready yet');
//       return;
//     }

//     const gridApi = gridRef.current.api;
//     if (!gridApi) {
//       console.warn('Grid API not initialized yet');
//       return;
//     }

//     gridApi.setFilterModel({});
//     gridRef.current.filterModelArr = {};

//     setOpenCustomFilterUi(false);
//     setAllFilter([{ ...filterTemp }]);
//     clearRedirectionFilter();
//   });
  // };
  

  const clearFilter = () => {
    const gridApi = gridRef?.current?.api;
    if (gridApi) {
      gridApi.setFilterModel({});
      gridRef.current = { ...gridRef.current, filterModelArr: {} }
      setOpenCustomFilterUi(false)
      setAllFilter([{ ...filterTemp }])
      clearRedirectionFilter()
    }
  }


  // useEffect(() => {
  //   if (customFilterData) {
  //     console.log('customFilterData', customFilterData)
  //     handleColumnSelect({
  //       target: {
  //         value: Object.keys(customFilterData)[0]
  //       }
  //     }, 0)
  //     handleFilterInput({
  //       target: {
  //         value: Object.values(customFilterData)[0]
  //       }
  //     }, 0, true)
  //     handleFilterActionSelect({
  //       target: {
  //         value: "Equal"
  //       }
  //     }, 0)

  //     handleApplyFilter(Object.keys(customFilterData)[0]?.toLowerCase())
  //     // handleApplyFilter(Object.keys(customFilterData)[0])
  //     setOpenCustomFilterUi(true)
  //   }
  // }, [customFilterData, gridRef])
    useEffect(() => {
    let key
    let value
    let condition

    if (customFilterData === 'all') {
      clearFilter()
    } else if (customFilterData) {
      if ((customFilterData?.type === 'End Date' || customFilterData?.type === 'Billing Cycle Date') && tableName === 'Contract') {
        key = {
          target: {
            value: customFilterData?.type
          }
        }
        const date = customFilterData.end_date1
        const [day, month, year] = date.split('-').map(Number);
        value = {
          date: new Date(year, month - 1, day),
          error: false
        }

        condition = {
          target: {
            value: customFilterData.action1
          }
        }
        const date2 = customFilterData.end_date2
        const [day2, month2, year2] = date2.split('-').map(Number);
        const value2 = {
          date: new Date(year2, month2 - 1, day2),
          error: false
        }
        handleColumnSelect({
          ...key
        }, 0)
        handleFilterInputTwo(value2, 0)
        handleFilterActionSelectTwo({
          target: {
            value: customFilterData.action2
          }
        }, 0)
        handleAndOrBtn(undefined, "or", 0)
      } else {
        key = {
          target: {
            value: titleCase(Object.keys(customFilterData)[0])
          }
        }

        if (Object.values(customFilterData)[1]) {
          value = {
            label: Object.values(customFilterData)[0],
            id: Object.values(customFilterData)[1],
          }
        } else {
          value = {
            target: {
              value: Object.values(customFilterData)[0]
            }
          }
        }
        condition = {
          target: {
            value: "Equal"
          }
        }

        handleColumnSelect({
          ...key
        }, 0)
      }

      handleFilterInput(value, 0, true)
      handleFilterActionSelect({
        ...condition
      }, 0)
      handleApplyFilter(Object.keys(customFilterData)[0])
      setOpenCustomFilterUi(true)
    }
  }, [customFilterData, gridRef?.current])
  /* =========================================== */


  /** ************GroupBy*********************** */
  const [groupByEl, setGroupByEl] = useState(null);
  const openGroupByPopUp = Boolean(groupByEl);
  const [rowSelectionCheckboxGroupBy, setRowSelectionCheckboxGroupBy] = useState({})
  const [groupByArr, setGroupByArr] = useState([])
  const [groupByArrAsset, setGroupByArrAsset] = useState([])

  const setDefaultRowSelectionCheckboxGroupBy = () => {
    return (() => {
      const initialState = {};
      Object.keys(columnHeaderAndValueMap || {}).map(item => {
        initialState[item] = false;
      });
      return initialState;
    })
  }
  useEffect(() => {
    setRowSelectionCheckboxGroupBy(setDefaultRowSelectionCheckboxGroupBy());
  }, [columns])

  useEffect(() => {
    requestIdleCallback(() => {
      if (!(gridRef?.current?.api?.getRowGroupColumns().length)) {
        setGroupByArr([])
        setGroupByArrAsset([])
        setRowSelectionCheckboxGroupBy(setDefaultRowSelectionCheckboxGroupBy());
      }
    })

  }, [gridRef, groupByEl])

  useEffect(() => {
    if (!groupByArrFromList.length) {
      setRowSelectionCheckboxGroupBy(setDefaultRowSelectionCheckboxGroupBy());
      setRowGroupPanelShow(false)
      setGroupByArr([])
      setGroupByArrAsset([])
    } else {
      const newGroup = []
      Object.keys(rowSelectionCheckboxGroupBy).map((item) => {
        if (groupByArrFromList.find(ele => ele.colDef?.headerName === item)) {
          newGroup.push(item)
          setRowSelectionCheckboxGroupBy(prevArray => ({
            ...prevArray,
            [item]: true
          }))
        } else {
          setRowSelectionCheckboxGroupBy(prevArray => ({
            ...prevArray,
            [item]: false
          }))
        }
      })
      setRowGroupPanelShow('always')
      setGroupByArr(newGroup)
      setGroupByArrAsset(newGroup)
      // gridRef?.current?.columnApi?.setRowGroupColumns(col_ids);
    }
  }, [groupByArrFromList])

  // useEffect(()=>{
  //   handleGroupByCreate()
  // },[groupByArr])

  const handleGroupByCancel = () => {
    setRowGroupPanelShow('never')
    setGroupByArr([])
    setGroupByArrAsset([])
    const {api} = gridRef.current;
    api.applyColumnState({
        state: [],
        defaultState: { rowGroup: false }
    });
    setRowSelectionCheckboxGroupBy(setDefaultRowSelectionCheckboxGroupBy());
    setGroupByEl(null)
  }

  const handleGroupByCreate = () => {
    setRowGroupPanelShow('always')
    const col_ids = []
    for (const key of groupByArr) {
      if (columnHeaderAndValueMap[key]) {
        col_ids.push(columnHeaderAndValueMap[key])
      }
    }

    gridRef?.current?.api?.setRowGroupColumns(col_ids);
    // 👇 Force grouped columns to stay visible
    col_ids.forEach(colId => {
      const column = gridRef.current.api.getColumn(colId);
      if (column) {
        gridRef.current.api.applyColumnState({
          state: [{ colId, hide: false }]
      });
       // gridRef?.current?.columnApi?.setColumnVisible(colId, true);
      }
    });

    setGroupByArrAsset(col_ids)
    setGroupByEl(null)
  }
  
  const dropdownClick = (event) => {
    setGroupByEl(groupByEl ? null : event.currentTarget)
  }

  const handleFilterClose = () => {
    setGroupByEl(null)
  }
  /* =========================================== */


  /** ************Hide Column*********************** */
  const [rowSelectionCheckbox, setRowSelectionCheckbox] = useState({})
  const [filterElHideColumn, setFilterElHideColumn] = useState(null);
  const [moreActions, setMoreActions] = useState(null);
  const [totalShowColumn, setTotalShowColumn] = useState(null);

  useEffect(() => {
    setDefaultHideColumnCheckBox()
  }, [columns])

  function isHideColumnApply() {
    const columnApi = gridRef?.current?.api;
    if (!columnApi) return false;

    const columnState = columnApi.getColumnState();
    const colPresent = columnState?.find(col => col.hide === true);

    return !!colPresent;
  }

  useEffect(() => {
    !isHideColumnApply() && setDefaultHideColumnCheckBox()
  }, [gridRef, filterElHideColumn])


  const setDefaultHideColumnCheckBox = () => {
    setRowSelectionCheckbox(() => {
       return columns?.reduce((acc, col) => {
    const colDef = col.getColDef();

    if (colDef?.headerName) {
      acc[colDef.headerName] = true;
    }
    return acc;
  }, {});
    })
  }

  const dropdownClickHideColumn = (event) => {
    setFilterElHideColumn(groupByEl ? null : event.currentTarget)
  }
  const handleFilterCloseHideColumn = () => {
    setFilterElHideColumn(null)
  }
  const openFilterHideColumn = Boolean(filterElHideColumn);
  const id_two = 'simple-popper_two'

  const handleHideColumn = () => {
    for (const key in rowSelectionCheckbox) {
      if (!rowSelectionCheckbox[key]) {
        const col = gridRef.current.api.getColumnDef(columnHeaderAndValueMap[key]);
        if (col) {
          gridRef.current.api.applyColumnState({
            state: [{ colId: columnHeaderAndValueMap[key], hide: true }],
            applyOrder: false,
          });
        }
      } else {
        const col = gridRef.current.api.getColumnDef(columnHeaderAndValueMap[key]);
        if (col) {
          gridRef.current.api.applyColumnState({
            state: [{ colId: columnHeaderAndValueMap[key], hide: false }],
            applyOrder: false,
          });
        }
        // gridRef?.current?.api?.setColumnVisible(columnHeaderAndValueMap[key], true);
      }
    }
    setFilterElHideColumn(null)
  }


  const dropdownClickMoreAction = (event) => {
    setMoreActions(event.currentTarget)
  }
  const handleFilterCloseMoreActions = () => {
    setMoreActions(null)
  }
  const openMoreAction = Boolean(moreActions);
  const id_more_action = 'simple-popper_more'

  useEffect(() => {
    if (rowSelectionCheckbox) {
      setTotalShowColumn((Object.values(rowSelectionCheckbox).filter(val => val === true)).length)
    }
  }, [rowSelectionCheckbox])

  const handleHideColumnCloseButton = () => {
    for (const key in rowSelectionCheckbox) {
      if (columnHeaderAndValueMap[key]) {
        gridRef.current.api.applyColumnState({
              state: [{ colId: columnHeaderAndValueMap[key], hide: false }],
              applyOrder: false,
            });
      }
      // gridRef?.current?.api.setColumnVisible(columnHeaderAndValueMap[key], true);
    }
    setDefaultHideColumnCheckBox()
    setFilterElHideColumn(null)
  }
  /* =========================================== */


  /** ************ServiceTicket***************** */
  // function handleServiceTicketCreation() {
  //   console.log('handleServiceTicketCreation');
  // }
  /* =========================================== */

  /** ************Exports***************** */
  const [exportType, setExportType] = useState('')
  const handleChangeExport = (event) => {
    setExportType(event.target.value);
  };

  useEffect(async () => {
    if (exportType) {
      setFileDownloadLoader(true)
      await multiFormatFileManager(exportType, tableName === 'activity_logs' ? `${activityModuleName}_activity_logs` : tableName, gridRef)
      setFileDownloadLoader(false)
      setExportType('')
    }

  }, [exportType])


  /* =========================================== */
  const handleFilterDelete = () => {
    const newFilterArr = [...allFilter]
    newFilterArr.pop()
    setAllFilter(newFilterArr)
  }
  /* =============================================================*/

  /** *******************************For Asset Service Ticket************** */

  useEffect(() => {
    if (allArchiveId.length) setRowSelected(true)
    else setRowSelected(false)
  }, [allArchiveId])


  useEffect(() => {
    requestIdleCallback(() => {
      if (gridRef?.current && columns?.length !== 0 && columns !== undefined) {
        for (const item of columns) {
          if (!item?.visible) {
            setRowSelectionCheckbox(prevArray => ({
              ...prevArray,
              [item?.userProvidedColDef.headerName]: false
            }))
          }
          if (item?.rowGroupActive) {
            setRowSelectionCheckboxGroupBy(prevArray => ({
              ...prevArray,
              [item.userProvidedColDef.headerName]: true
            }))
          }
        }
      }
    })
  }, [gridRef?.current, columns])

  useEffect(() => {
    if (!filterElHideColumn) setColumnNameSearchValue(null)
  }, [filterElHideColumn])

  function filterKeysStartingWith(value) {
    const filteredObj = {};
    Object.keys(columnHeaderAndValueMap).forEach(key => {
      if (key.toLowerCase()?.includes(value.toLowerCase())) {
        filteredObj[key] = columnHeaderAndValueMap[key];
      }
    });
    return filteredObj;
  }

  const columnNameSearch = (e) => {
    const val = filterKeysStartingWith(e.target.value)

    setFilterColumnHeaderAndValueMap(val)
    setColumnNameSearchValue(e.target.value)
  }

  const removeAllSelectedCheckbox = () => {
    setRowSelectionCheckbox(() => {
      return columns?.reduce((res, curr) => {
        res[curr.userProvidedColDef?.headerName] = false
        return res
      }, {})
    })
  }

  return (
    <div>
      {fileDownloadLoader && <FuseLoading />}
      {tableName === 'customer_management' && <div role="presentation" className="cstm_breadcrumbs_holder">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit">
            System Settings
          </Link>
          <span>{tableName === 'customer_management' ? 'Customer Management' : ''}</span>
        </Breadcrumbs>
      </div>}
      <Box style={{ marginBottom: hideTableName ? '16px' : '0px' }} sx={{ width: '100%', marginTop: '36px' }}>

        {!hideTableName && <Typography
          style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}
          className='allAssets_text'
        >
          <div>
            {(displayTableName === 'All Assets') ?
              (gridRef?.current?.columnApi?.getRowGroupColumns().length ? 'All Assets Grouping' : 'All Assets') :
              tableName === 'service_request' ? 'Listed Service Tickets' :
                tableName === 'customer_management' ? 'Listed Customers' : displayTableName
            }
            {displayTableName === 'All Assets' && <span className='devices_text'>({asset_count})</span>}
            {(tableName === 'service_request' || tableName === 'agents' || tableName === 'customer_management') && serviceRequestTotalRecords && <span className='devices_text'> ({serviceRequestTotalRecords})</span>}
            {/* {(tableName === 'customer_management') && totalCustomer && <span className='devices_text'> ({totalCustomer})</span>} */}

          </div>
          {tableName === 'service_request' &&
            <Button style={{ marginRight: '2px' }} className='gradient_animated_button focus_mode_btn' onClick={() => router.push("/service-tickets/focus-details")}>
              <i className='ti ti-bolt' />
              Focus Mode
            </Button>
          }

        </Typography>}

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ backgroundColor: !hideTableName ? '#e9ebed' : '', padding: '8px', borderRadius: '8px', marginBottom: hideTableName ? '0px' : '10px' }}>
            {!hideTableName && <Tabs value={tableName === 'Archived Asset' ? null : tabValue} onChange={handleChangeTab} aria-label="basic tabs example" className='category_tabs'>
              <Tab className="tabs_exampleText" label={displayTableName === 'All Alert List' ? 'Unresolved Alert List' : displayTableName} />
              {showActivity?.includes(tableName) && <Tab className="tabs_exampleText" label="Activities" />}
              {['Alert List'].includes(tableName) && <Tab className="tabs_exampleText" label="All Alert List" />}
            </Tabs>}
            {
              hideTableName && <Typography
                className='allAssets_text mb-0'
              >{displayTableName}</Typography>
            }
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {hideAddButton() && tabValue === 0 &&
              <div className='primary_maroon_btn icon_primary_btn filter_icon' onClick={() => {
                onClickAddButton()
              }}>
                <i className='ti ti-plus icon' />
              </div>
            }

            {rowSelected &&
              <Button onClick={bulkAssetArchive} className='create_button mr-12'><i className='ti ti-archive' />Archive</Button>
            }
            {rowSelected &&
              <Button onClick={handleServiceTicketCreation} className='create_button mr-12'><i className='ti ti-ticket' />Service Ticket</Button>
            }
            {/* Filter and Archive*/}
            {!rowSelected &&
              <div className="filter_icon" onClick={openFilter}>
                <i style={{ fontSize: '18px' }} className='ti ti-filter' />
              </div>
            }
            <div onClick={dropdownClickHideColumn} className='filter_icon'>
              <i className='ti ti-layout-columns' />
            </div>
            <Popover
              id={id_two}
              open={openFilterHideColumn}
              anchorEl={filterElHideColumn}
              onClose={handleFilterCloseHideColumn}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              style={{ marginTop: "1px" }}
            >
              <div className='dropdown_listGroup'>
                <div>
                  <Typography className='group_columnText'>Show Columns({totalShowColumn})</Typography>
                </div>
                <div style={{ height: '190px', overflowY: 'scroll' }} className='thinscrollbar_holder'>
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div style={{ width: '100%', padding: '0 12px 12px' }}>
                      <div className='cstm_input_container'>
                        <input
                          // variant="outlined"
                          placeholder="Search column..."
                          // fullWidth
                          // inputProps={{ readOnly: false }}
                          required
                          onChange={columnNameSearch}
                          value={columnNameSearchValue}
                        />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', paddingTop: '8px' }}>
                        <Checkbox className='checkbox_padding'
                          sx={{
                            color: '#eaecf0',
                            '&.Mui-checked': {
                              color: '#f66d69',
                            },
                          }}
                          checked={selectAll}
                          onChange={(e) => {
                            setSelectAll(e.target.checked)
                            if (e.target.checked) setDefaultHideColumnCheckBox()
                            else removeAllSelectedCheckbox()

                          }}
                        />

                        <Typography style={{ display: 'inline-flex', alignItems: 'center' }} className='list_text'>Select All</Typography>
                      </div>
                    </div>
                  </div>
                  {(columnNameSearchValue ? Object.keys(filterColumnHeaderAndValueMap) : Object.keys(columnHeaderAndValueMap || {}))?.map((item) => {
                    return (
                      <div className='checkbox_list'>
                        <span style={{ marginRight: '5px' }}>
                          {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_2657_16034)">
                              <path d="M6.00016 3.99984C6.36835 3.99984 6.66683 3.70136 6.66683 3.33317C6.66683 2.96498 6.36835 2.6665 6.00016 2.6665C5.63197 2.6665 5.3335 2.96498 5.3335 3.33317C5.3335 3.70136 5.63197 3.99984 6.00016 3.99984Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M6.00016 8.66683C6.36835 8.66683 6.66683 8.36835 6.66683 8.00016C6.66683 7.63197 6.36835 7.3335 6.00016 7.3335C5.63197 7.3335 5.3335 7.63197 5.3335 8.00016C5.3335 8.36835 5.63197 8.66683 6.00016 8.66683Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M6.00016 13.3333C6.36835 13.3333 6.66683 13.0349 6.66683 12.6667C6.66683 12.2985 6.36835 12 6.00016 12C5.63197 12 5.3335 12.2985 5.3335 12.6667C5.3335 13.0349 5.63197 13.3333 6.00016 13.3333Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M10.0002 3.99984C10.3684 3.99984 10.6668 3.70136 10.6668 3.33317C10.6668 2.96498 10.3684 2.6665 10.0002 2.6665C9.63197 2.6665 9.3335 2.96498 9.3335 3.33317C9.3335 3.70136 9.63197 3.99984 10.0002 3.99984Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M10.0002 8.66683C10.3684 8.66683 10.6668 8.36835 10.6668 8.00016C10.6668 7.63197 10.3684 7.3335 10.0002 7.3335C9.63197 7.3335 9.3335 7.63197 9.3335 8.00016C9.3335 8.36835 9.63197 8.66683 10.0002 8.66683Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M10.0002 13.3333C10.3684 13.3333 10.6668 13.0349 10.6668 12.6667C10.6668 12.2985 10.3684 12 10.0002 12C9.63197 12 9.3335 12.2985 9.3335 12.6667C9.3335 13.0349 9.63197 13.3333 10.0002 13.3333Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_2657_16034">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg> */}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Checkbox className='checkbox_padding'
                            sx={{
                              color: '#eaecf0',
                              '&.Mui-checked': {
                                color: '#f66d69',
                              },
                            }}
                            checked={rowSelectionCheckbox[item]} onChange={() => {
                              const data = Object.keys(rowSelectionCheckbox).filter(key => rowSelectionCheckbox[key] === true);
                              if (data.length === 1 && rowSelectionCheckbox[item]) {
                                toast.error('You cannot uncheck all columns!')
                              } else {
                                setRowSelectionCheckbox(prevArray => ({
                                  ...prevArray,
                                  [item]: !rowSelectionCheckbox[item]
                                }))
                              }

                            }} />

                          <Typography className='list_text'>{item}</Typography>
                        </div>
                      </div>
                    )
                  })
                  }
                </div>
                <Box sx={{ display: 'flex', marginTop: '6px', padding: '4px 12px' }}>
                  <Button onClick={handleHideColumnCloseButton} className='cancel_button w-full'>Reset</Button>
                  <Button className='create_button w-full' onClick={handleHideColumn}>Create</Button>
                </Box>
              </div>
            </Popover>

            {rowSelected && <>
              <div className="filter_icon" onClick={dropdownClickMoreAction}>
                <i className='ti ti-dots-vertical' />
              </div>

              <Popover
                id={id_more_action}
                open={openMoreAction}
                anchorEl={moreActions}
                onClose={handleFilterCloseMoreActions}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <div className='cstm_dropwdown_holder'>
                  <div className='each_holder' onClick={openFilter}>
                    <i className='ti ti-eye' />
                    <span>Filter</span>
                  </div>
                  <div className='each_holder' onClick={dropdownClick}>
                    <i className='ti ti-archive' />
                    <span>Group By</span>
                    <i className='ti ti-chevron-down ml-2' />
                  </div>
                </div>
              </Popover>
            </>}

            {/* GroupBy and Create Service Tickets */}
            <Box sx={{ display: 'flex', alignItems: "center", marginRight: '5px' }}>
              {!rowSelected && <>
                <Button className='group_field' onClick={dropdownClick}>
                  Group By <Icon>
                    expand_more
                  </Icon>
                </Button>
              </>}
              <Popover
                id='simple-popper'
                open={openGroupByPopUp}
                anchorEl={groupByEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                style={{ marginTop: "1px" }}
              >
                <div className='dropdown_listGroup'>
                  <div>
                    <Typography className='group_columnText'>Group Column</Typography>
                  </div>
                  <div style={{ height: '202px', overflowY: 'scroll' }} className='thinscrollbar_holder'>
                    {Object.keys(columnHeaderAndValueMap || {}).map((item) => {
                      return (
                        <div className='checkbox_list'>
                          <span style={{ marginRight: '5px' }}>
                            {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clipPath="url(#clip0_2657_16034)">
                                <path d="M6.00016 3.99984C6.36835 3.99984 6.66683 3.70136 6.66683 3.33317C6.66683 2.96498 6.36835 2.6665 6.00016 2.6665C5.63197 2.6665 5.3335 2.96498 5.3335 3.33317C5.3335 3.70136 5.63197 3.99984 6.00016 3.99984Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6.00016 8.66683C6.36835 8.66683 6.66683 8.36835 6.66683 8.00016C6.66683 7.63197 6.36835 7.3335 6.00016 7.3335C5.63197 7.3335 5.3335 7.63197 5.3335 8.00016C5.3335 8.36835 5.63197 8.66683 6.00016 8.66683Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6.00016 13.3333C6.36835 13.3333 6.66683 13.0349 6.66683 12.6667C6.66683 12.2985 6.36835 12 6.00016 12C5.63197 12 5.3335 12.2985 5.3335 12.6667C5.3335 13.0349 5.63197 13.3333 6.00016 13.3333Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.0002 3.99984C10.3684 3.99984 10.6668 3.70136 10.6668 3.33317C10.6668 2.96498 10.3684 2.6665 10.0002 2.6665C9.63197 2.6665 9.3335 2.96498 9.3335 3.33317C9.3335 3.70136 9.63197 3.99984 10.0002 3.99984Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.0002 8.66683C10.3684 8.66683 10.6668 8.36835 10.6668 8.00016C10.6668 7.63197 10.3684 7.3335 10.0002 7.3335C9.63197 7.3335 9.3335 7.63197 9.3335 8.00016C9.3335 8.36835 9.63197 8.66683 10.0002 8.66683Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10.0002 13.3333C10.3684 13.3333 10.6668 13.0349 10.6668 12.6667C10.6668 12.2985 10.3684 12 10.0002 12C9.63197 12 9.3335 12.2985 9.3335 12.6667C9.3335 13.0349 9.63197 13.3333 10.0002 13.3333Z" stroke="#667085" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_2657_16034">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg> */}
                          </span>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox className='checkbox_padding'
                              sx={{
                                color: '#eaecf0',
                                '&.Mui-checked': {
                                  color: '#f66d69',
                                },
                              }}
                              checked={rowSelectionCheckboxGroupBy[item]} onChange={() => {

                                setRowSelectionCheckboxGroupBy(prevArray => ({
                                  ...prevArray,
                                  [item]: !rowSelectionCheckboxGroupBy[item]
                                }))
                                const newArr = [...groupByArr]
                                const indexToRemove = newArr.indexOf(item);
                                if (indexToRemove !== -1) {
                                  newArr.splice(indexToRemove, 1);
                                } else {
                                  newArr.push(item)
                                }
                                setGroupByArr(newArr)
                              }} />
                            <Typography className='list_text'>{item}</Typography>
                          </div>
                        </div>
                      )
                    })
                    }
                  </div>
                  <Box sx={{ display: 'flex', marginTop: '6px', padding: '4px 12px' }}>
                    <Button onClick={handleGroupByCancel} className='cancel_button w-full my-0'>Reset</Button>
                    <Button className='create_button w-full my-0' onClick={handleGroupByCreate}>Group</Button>
                  </Box>
                </div>
              </Popover>
            </Box>
            {/* Exporting */}
            {(!hideExportAs?.includes(tableName) && !forActivity) && <Box sx={{ minWidth: 108 }}>
              <FormControl fullWidth className='cstm_select_formcontrol'>
                {/* <InputLabel id="demo-simple-select-label">Export As</InputLabel> */}
                <Select
                  displayEmpty
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className='export_field'
                  value={exportType}
                  onChange={handleChangeExport}
                  renderValue={(selected) => {
                    if (selected?.length === 0) {
                      return <span className="placeholder_title">Export As</span>;
                    }
                    return selected;
                  }}
                >
                  <MenuItem disabled value="">
                    <span style={{ display: 'none' }} className="placeholder_title">Export As</span>
                  </MenuItem>
                  <MenuItem value="CSV">CSV</MenuItem>
                  <MenuItem value="Excel">Excel</MenuItem>
                  <MenuItem value="PDF">PDF</MenuItem>
                </Select>
              </FormControl>
            </Box>}
          </Box>
        </Box>

        <CustomTabPanel className='custom_tab' value={tabValue} index={tabValue}>
          {openCustomFilterUi && <Box className="filter_box">
            <><Typography sx={{ color: "#1D2939", fontSize: '12px', fontWeight: '500', lineHeight: '16px', fontFamily: '"Inter", sans-serif', marginBottom: '10px' }}>FILTER</Typography>

              <Box sx={{}}>
                {!isLoading && allFilter.map((item, index) =>
                (
                  <>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', backgroundColor: "#FCFCFD", border: '1px solid #EAECF0', padding: '10px', borderRadius: "4px", marginBottom: '5px' }}>
                      <Box sx={{ display: 'flex' }}>
                        <Box sx={{ minWidth: 120, margin: '5px' }}>
                          <FormControl fullWidth className='serialNumberText_field cstm_select_formcontrol h-full p-4'>
                            <InputLabel id="demo-simple-select-label">Column Name</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              style={{ maxWidth: '150px' }}
                              className='serialNumber_field h-full'
                              id="demo-simple-select"
                              value={item.column}
                              label="Column Name"
                              onChange={(e) => { handleColumnSelect(e, index) }}
                              MenuProps={{
                                sx: {
                                  maxHeight: 350,
                                  '& .MuiMenuItem-root': {
                                    whiteSpace: 'normal',
                                  },
                                },
                              }}
                            >
                              {Object.keys(columnHeaderAndValueMap || {}).map(el => (<MenuItem value={el}>{el}</MenuItem>))}

                            </Select>
                          </FormControl>
                        </Box>
                        <Box sx={{ minWidth: 120, margin: '5px' }}>
                          <FormControl fullWidth className='serialNumberText_field cstm_select_formcontrol h-full' error={item.error.actionError}>
                            <InputLabel id="demo-simple-select-label">Operator</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              className='serialNumber_field h-full'
                              value={item?.action ? ((item?.column?.toLowerCase()?.includes('time') || item?.column?.toLowerCase()?.includes('date')) && ['Contains', 'Not Contains'].includes(item?.action) ? (item?.action === "Contains" ? 'Equal' : 'Not Equal') : item?.action) : item?.action}
                              label="Operator"
                              onChange={(e) => { handleFilterActionSelect(e, index) }}
                              MenuProps={{
                                sx: {
                                  maxHeight: 350,
                                  '& .MuiMenuItem-root': {
                                    whiteSpace: 'normal',
                                  },
                                },
                              }}
                            >
                              {(item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) ? Object.keys(['service_request', 'Alert List'].includes(tableName) ? serviceTicketCreatedAtFilter : dateFilter).map(el => (<MenuItem value={el}>{el}</MenuItem>)) : Object.keys(filterAction).map(ele => (<MenuItem value={ele}>{ele}</MenuItem>))}
                            </Select>
                          </FormControl>
                        </Box>
                        <Box sx={{ margin: '5px' }}>
                          <FormControl style={{ width: 160 }} className='filterText_field deep_input_holder h-full'>
                            {/* <Controller
                                        name="filter_input"
                                        className="mb-16"
                                        defaultValue={''}
                                        control={control}
                                        render={({ field }) => (
                                            <> */}
                            {(!(item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) && !(dropdownFilterColumns?.includes(item.column?.trimEnd()) && dropDownFilterModule?.includes(tableName))) && <TextField
                              // {...field}
                              variant='outlined'
                              placeholder='Filter Value'
                              required
                              value={item.inputVal}
                              onChange={(e) => { handleFilterInput(e, index) }}
                              style={{ background: 'white', height: '100%' }}
                              className='textfield_holder'
                            />}
                            {(['Client Name', 'Company Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Company"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllCompany}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.company_name } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['User', 'User Name', 'Agent Name', 'Customer Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User"
                              searchEnabled
                              listCall={getAllUser}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={item.column === 'Agent Name' ? { type: 'agent' } : {}}
                            />}
                            {(['Status', 'Asset Status', 'Status Name']?.includes(item.column) && ['asset', 'Archived Asset', 'asset_status', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Asset Status"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetStatus}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Contract Number' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Contract Number"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllContract}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Contract Tag', 'Contract Tag Name']?.includes(item.column?.trimEnd()) && ['Contract', 'Archived Contract', 'contract_tag', 'asset', 'Archived Asset']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Contract Tag"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllContractStatus}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Model Name', 'Model']?.includes(item.column) && ['Model', 'activity_logs', 'asset', 'Archived Asset', 'Accessory', 'Insight log']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Name"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetModel}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'model_name' }}
                            />}
                            {(['Model Number', 'Model No'].includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Number"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetModel}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'model_no' }}
                            />}
                            {(['Asset Category', 'Category', 'Category Name']?.includes(item.column?.trimEnd()) && ['asset', 'Archived Asset', 'asset_category', 'service_request_category', 'Model', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Category"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetCategory}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Manufacturer', 'Manufacturer Name']?.includes(item.column?.trimEnd()) && ['Model', 'Manufacture', 'Accessory', 'activity_logs', 'asset', 'Archived Asset', 'Insight log']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Manufacturer"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetManufacturer}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Location', 'Location Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Location"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllLocation}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Accessory', 'Accessory Name']?.includes(item.column?.trimEnd()) && ['Accessory', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Accessory"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetAccessory}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Type', 'Contract Type Name']?.includes(item.column) && ['Contract', 'Archived Contract', 'Contract Types', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Type"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: typeof item.inputVal === 'object' ? item.inputVal.id : item.id, label: typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal, key: `${typeof item.inputVal === 'object' ? item.inputVal.id : item.id}|${typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal}` } : null} listCall={getAllContracType}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Service Provider', 'Service Provider Name']?.includes(item.column) && ['Contract', 'Archived Contract', 'service_provider', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Provider"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: typeof item.inputVal === 'object' ? item.inputVal.id : item.id, label: typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal, key: `${typeof item.inputVal === 'object' ? item.inputVal.id : item.id}|${typeof item.inputVal === 'object' ? item.inputVal.label : item.inputVal}` } : null} listCall={getAllAssetServiceProvider}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Serial Number' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Asset"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAsset}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Priority' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Priority"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllPriority}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Status' && dropDownFilterModule?.includes(tableName) && ['service_request', 'Archived Service Tickets', 'service_template']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Status"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllStatus}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Location Type Name', 'Location Type']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Location Type"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllLocationType}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Department', 'Department Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Department"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllDepartment}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column?.trimEnd() === 'Accessory Category' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Accessory Category"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAssetAccessoryCategory}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Mac Address' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Mac Address"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllAsset}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'mac_id' }}
                            />}
                            {(item.column?.replace(/\s/g, '') === 'Source' && ['asset', 'Manufacture', 'asset_category', 'Accessory', 'custom_attributes', 'accessory_category', 'shipping', 'Model']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(assets_source || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column?.replace(/\s/g, '') === 'Source' && ['service_provider', 'user']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(source || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Type' && ['service_template']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(serviceTemplateType || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Network Status' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(assets_network_status || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Notification Status' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.keys(asset_notification_status || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Contract Status' && ['Contract', 'Archived Contract', 'asset', 'Archived Asset']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(contract_status || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Master' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(contract_master || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'New/renew' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {['New', 'Renew'].map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Status' && tableName === 'user') &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {['Active', 'Inactive'].map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Email' && tableName === 'user') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User Email"
                              searchEnabled
                              listCall={getAllUser}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'email' }}
                            />}
                            {(item.column === 'Name' && dropdownFilterColumns?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User Name"
                              searchEnabled
                              listCall={getAllUser}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'name' }}
                            />}
                            {(['Role Name', 'User Role']?.includes(item.column?.trimEnd()) && ['user', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Role Name"
                              searchEnabled
                              listCall={getAllRoles}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Model Attribute', 'Attribute Name']?.includes(item.column?.trimEnd()) && ['custom_attributes', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Attribute"
                              searchEnabled
                              listCall={getAllAssetCustomAttribute}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Payment Term Name' && ['payment_term', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Payment Term"
                              searchEnabled
                              listCall={getAllContracPaymentTerm}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Service Level Agreement Name' && ['service_level_agreement', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Level Agreement"
                              searchEnabled
                              listCall={getAllContracServiceLevelAgrement}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Ticket Id', 'Ticket Number']?.includes(item.column) && ['service_request', 'Archived Service Tickets', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Ticket Id"
                              searchEnabled
                              listCall={getAllServiceRequest}
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Action' && dropdownFilterColumns?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputVal}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInput(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(actions || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(['Service Ticket Category Name', 'Category'].includes(item.column) && ['service_request_category', 'service_template'].includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Category"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllCategory}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Service Ticket Source Name', 'Source'].includes(item.column) && ['service_request_source', 'service_template'].includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Source"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllSource}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Priority Name' && tableName === 'service_ticket_priority') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Priority"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllPriority}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Status Name'].includes(item?.column) && ['service_request_status'].includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Status"
                              searchEnabled
                              defaultValue={item.inputVal ? { id: item.id, label: item.inputVal, key: `${item.id}|${item.inputVal}` } : null}
                              listCall={getAllStatus}
                              emitItem={(value) => {
                                handleFilterInput(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {/* { groupByModule?.includes(tableName) &&
                              <TextField
                              // {...field}
                                variant='outlined'
                                placeholder='Filter Value'
                                required
                                value={item.inputVal}
                                onChange={(e) => { handleFilterInput(e, index) }}
                              />
                            } */}
                            {(item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) && <CustomDatePickerV2
                              state={item.inputVal}
                              setState={setDateInputValOne}
                              key={item?.column}
                              required={false}
                              label=''
                              onChangeFromParent={(e) => { handleFilterInput(e, index) }}
                            />}
                            {/* </> */}
                            {/* )}
                      /> */}
                          </FormControl>
                        </Box>
                      </Box>
                      {allFilter[index].action !== 'From' && (
                        <div style={{ margin: '5px' }} className="two_btns_holder">
                          {/* <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='add_OrTabs'> */}
                          <Button className={`add_tabs_text ${allFilter[index].operator === 'AND' ? 'active' : ''}`} onClick={(e) => { handleAndOrBtn(e, "and", index) }}>and</Button>
                          <Button className={`dd_tabs_text ${allFilter[index].operator === 'OR' ? 'active' : ''}`} label="Or" onClick={(e) => { handleAndOrBtn(e, "or", index) }}>or</Button>
                          {/* </Tabs> */}
                        </div>
                      )}
                      <Box sx={{ display: 'flex' }}>
                        <Box sx={{ minWidth: 120, margin: '5px' }}>
                          <FormControl fullWidth className='serialNumberText_field cstm_select_formcontrol' error={item.error.actionTwoError}>
                            <InputLabel id="demo-simple-select-label">Operator</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              className='serialNumber_field'
                              value={item.actionTwo}
                              label="Operator"
                              disabled={allFilter[index].action === 'From'}
                              onChange={(e) => { handleFilterActionSelectTwo(e, index) }}
                              MenuProps={{
                                sx: {
                                  maxHeight: 350,
                                  '& .MuiMenuItem-root': {
                                    whiteSpace: 'normal',
                                  },
                                },
                              }}
                            >

                              {((item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) ? (Object.keys(['service_request', 'Alert List'].includes(tableName) && allFilter[index]?.action === 'From' ? { ...dateFilter, 'To': 'to' } : dateFilter)) : Object.keys(filterAction)).map(ele => (<MenuItem value={ele}>{ele}</MenuItem>))}
                            </Select>
                          </FormControl>
                        </Box>

                        <Box sx={{ margin: '5px' }}>
                          <div style={{ width: 160 }} className='filterText_field deep_input_holder'>
                            {(!(item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) && !(dropdownFilterColumns?.includes(item.column?.trimEnd()) && dropDownFilterModule?.includes(tableName))) && <TextField
                              // {...field}
                              variant='outlined'
                              placeholder='Filter Value'
                              required
                              value={item.inputValTwo}
                              onChange={(e) => { handleFilterInputTwo(e, index) }}
                            />}
                            {(['Client Name', 'Company Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Company"
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              searchEnabled
                              listCall={getAllCompany}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.company_name } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['User', 'User Name', 'Agent Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllUser}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={item.column === 'Agent Name' ? { type: 'agent' } : {}}
                            />}
                            {(['Status', 'Asset Status', 'Status Name']?.includes(item.column) && ['asset', 'Archived Asset', 'asset_status', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Asset Status"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetStatus}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Contract Number' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Contract Number"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllContract}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Contract Tag', 'Contract Tag Name']?.includes(item.column) && ['Contract', 'Archived Contract', 'contract_tag', 'asset', 'Archived Asset']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Contract Tag"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllContractStatus}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Model Name', 'Model']?.includes(item.column) && ['Model', 'activity_logs', 'asset', 'Archived Asset', 'Accessory', 'Insight log']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Name"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetModel}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'model_name' }}
                            />}
                            {(item.column === 'Model Number' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Number"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetModel}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'model_no' }}
                            />}
                            {(['Asset Category', 'Category', 'Category Name']?.includes(item.column?.trimEnd()) && ['asset', 'asset_category', 'Model', 'activity_logs', 'service_request_category', 'Archived Asset']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Category"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetCategory}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Manufacturer', 'Manufacturer Name']?.includes(item.column?.trimEnd()) && ['Model', 'asset', 'Manufacture', 'Accessory', 'activity_logs', 'Archived Asset', 'Insight log']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Manufacturer"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetManufacturer}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Location', 'Location Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Location"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllLocation}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Type', 'Contract Type Name']?.includes(item.column) && ['Contract', 'Archived Contract', 'Contract Types', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Type"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllContracType}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Service Provider', 'Service Provider Name']?.includes(item.column) && ['Contract', 'Archived Contract', 'service_provider', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Provider"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetServiceProvider}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Serial Number' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Asset"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAsset}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Priority' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Priority"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllPriority}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Status' && dropDownFilterModule?.includes(tableName) && ['service_request', 'Archived Service Tickets', 'service_template']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Status"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllStatus}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Location Type Name', 'Location Type']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Location Type"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllLocationType}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Department', 'Department Name']?.includes(item.column) && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Department"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllDepartment}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column?.trimEnd() === 'Accessory Category' && dropDownFilterModule?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Accessory Category"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetAccessoryCategory}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Mac Address' && tableName === 'asset') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Mac Address"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAsset}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'mac_id' }}
                            />}
                            {(item.column?.replace(/\s/g, '') === 'Source' && ['asset', 'Manufacture', 'asset_category', 'Accessory', 'custom_attributes', 'accessory_category', 'shipping', 'Model']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(assets_source || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column?.replace(/\s/g, '') === 'Source' && ['service_provider', 'user']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(source || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Type' && ['service_template']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(serviceTemplateType || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Network Status' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(assets_network_status || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Contract Status' && ['Contract', 'Archived Contract', 'asset', 'Archived Asset']?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(contract_status || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Master' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(contract_master || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'New/renew' && dropDownFilterModule?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {['New', 'Renew'].map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Status' && tableName === 'user') &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {['Active', 'Inactive'].map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(item.column === 'Email' && tableName === 'user') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User Email"
                              searchEnabled
                              listCall={getAllUser}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'email' }}
                            />}
                            {(item.column === 'Name' && dropdownFilterColumns?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="User Name"
                              searchEnabled
                              listCall={getAllUser}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{ column: 'name' }}
                            />}
                            {(['Role Name', 'User Role']?.includes(item.column?.trimEnd()) && ['user', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Role Name"
                              searchEnabled
                              listCall={getAllRoles}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Model Attribute', 'Attribute Name']?.includes(item.column?.trimEnd()) && ['custom_attributes', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Model Attribute"
                              searchEnabled
                              listCall={getAllAssetCustomAttribute}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Payment Term Name' && ['payment_term', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Payment Term"
                              searchEnabled
                              listCall={getAllContracPaymentTerm}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Service Level Agreement Name' && ['service_level_agreement', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Level Agreement"
                              searchEnabled
                              listCall={getAllContracServiceLevelAgrement}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Ticket Id', 'Ticket Number']?.includes(item.column) && ['service_request', 'Archived Service Tickets', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Ticket Id"
                              searchEnabled
                              listCall={getAllServiceRequest}
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Action' && dropdownFilterColumns?.includes(tableName)) &&
                              <Select
                                labelId="demo-simple-select-label"
                                style={{ width: '160px' }}
                                className='serialNumber_field'
                                id="demo-simple-select"
                                value={item.inputValTwo}
                                placeholder="Filter Value"
                                onChange={(e) => { handleFilterInputTwo(e.target.value, index) }}
                                MenuProps={{
                                  sx: {
                                    maxHeight: 350,
                                    '& .MuiMenuItem-root': {
                                      whiteSpace: 'normal',
                                    },
                                  },
                                }}
                              >
                                {Object.values(actions || {}).map(item => (<MenuItem value={item}>{item}</MenuItem>))}
                              </Select>
                            }
                            {(['Accessory', 'Accessory Name']?.includes(item.column?.trimEnd()) && ['Accessory', 'activity_logs']?.includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Accessory"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllAssetAccessory}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Service Ticket Category Name', 'Category'].includes(item.column) && ['service_request_category', 'service_template'].includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Category"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllCategory}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(['Service Ticket Source Name', 'Source'].includes(item.column) && ['service_request_source', 'service_template'].includes(tableName)) && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Source"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllSource}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Priority Name' && tableName === 'service_ticket_priority') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Priority"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllPriority}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {(item.column === 'Status Name' && tableName === 'service_request_status') && <SearchDropDownListPaginationComponent
                              label="Filter Value"
                              module="Service Ticket Status"
                              searchEnabled
                              defaultValue={item.inputValTwo ? { id: item.id, label: item.inputValTwo, key: `${item.id}|${item.inputValTwo}` } : null}
                              listCall={getAllStatus}
                              emitItem={(value) => {
                                handleFilterInputTwo(value ? { id: value.id, label: value?.label } : null, index)
                              }}
                              apiParams={{}}
                            />}
                            {/* { !groupByModule?.includes(tableName) &&
                              <TextField
                              // {...field}
                                variant='outlined'
                                placeholder='Filter Value'
                                required
                                value={item.inputValTwo}
                                onChange={(e) => { handleFilterInputTwo(e, index) }}
                              />
                            } */}
                            {(item.column?.toLowerCase()?.includes("date") || item.column?.toLowerCase()?.includes("time")) && <CustomDatePickerV2
                              state={item.inputValTwo}
                              setState={setDateInputValTwo}
                              required={false}
                              key={item?.column}
                              label=''
                              onChangeFromParent={(e) => { handleFilterInputTwo(e, index) }}
                            />}
                          </div>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'flex-start', marginTop: '6px' }}>
                      <>
                        {(allFilter.length - 1 === index) && <Button
                          className='add_anotherButton mt-0 mr-3 p-1'
                          onClick={addAnotherFilter}
                          startIcon={
                            <Icon fontSize="small" title="Add Another">
                              add
                            </Icon>}>
                          Add Another</Button>
                        }
                        <div className="delete_filter_holder">
                          {(index !== 0) && <Icon onClick={() => { handleFilterDelete(index) }}>delete_outline_outlined</Icon>}
                        </div>
                      </>
                    </Box>
                    {/* </Box> */}
                  </>
                )
                )}
                {/* <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  className='add_anotherButton'
                  onClick={addAnotherFilter}
                  startIcon={
                    <Icon fontSize="small" title="Add Another">
                      add
                    </Icon>}>
                  Add Another</Button>
              </Box> */}
              </Box>
              <Box>
                <Button onClick={handleApplyFilter} className='apply_filterButton'>Apply Filter</Button>
                <Button onClick={clearFilter} className='apply_filterButton'>Clear Filter</Button>
              </Box>
            </>
          </Box>}

        </CustomTabPanel>
        {/* {showActivity?.includes(tableName) && <CustomTabPanel className='custom_tab' value={tabValue} index={1}>
          <ActivityAgGridListingSameAsSam module={tableName} logs={logs}  loadingLog={loadingLog}/>
        </CustomTabPanel>} */}
      </Box>
    </div>
  )
}

export default AgGridFilterGroupView;